const config = {
    "API_URL": "https://private.hirulicenses.com/",
    "API_LOCAL_URL": "http://localhost:5000/"
}

export default config;